// import { createConnection } from 'typeorm';
// import { M_SIPARIS_DETAY } from './../../models/M_SIPARIS_DETAY';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
// import { SQLitePorter } from '@ionic-native/sqlite-porter';


declare var openDatabase: any;
declare var window: any;




@Injectable()
export class DalProvider {

  static connection: any;
  constructor() {

  }

  createAndGetConnection(options: any) {
    return new Promise((res, err) => {

      if (options.storage == "web") {
        // console.log("database options", options)
        // var db = websqlDb(options);
        var db = openDatabase(options.database, "", options.description, 25 * 1024 * 1024);
        DalProvider.connection = db;
        db.transaction(function (tx) {
          DalProvider.createDatabase(tx);
          res(db)
        })
      }
      else {
        // this.sqlite.create({
        //   name: options.database,
        //   location: 'default'
        // }).then((db: SQLiteObject) => {
        //   DalProvider.connection = db;
        //   db.transaction(a=>{
        //     DalProvider.createDatabase(a);
        //     res(db);
        //   })


        //   // db.executeSql('create table danceMoves(name VARCHAR(32))', {})
        //   //   .then(() => console.log('Executed SQL'))
        //   //   .catch(e => console.log(e));
        // }).catch(e => console.log(e));
        var db = window.sqlitePlugin.openDatabase({ name: 'M724.db', location: 'default' }, function (success) {
          DalProvider.connection = db;
          db.transaction(function (tx) {
            DalProvider.createDatabase(tx);
            res(db)
          })
        }, function (error) { });
      }
    })

  }


  static createDatabase(tx) {
    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS M_SIPARIS_DETAY " +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "StokKartID double,"+
      "IslemTuru double,"+
      "FaturaID double,"+
      "SatirNo double,"+
      "CariKartID double,"+
      "DepoKodu double,"+
      "Miktar double,"+
      "BirimFiyat double,"+
      "IskontoOran1 double,"+
      "IskontoOran2 double,"+
      "IskontoOran3 double,"+
      "IskontoTutar double,"+
      "IskontoluBirimFiyati double,"+
      "AraTutar double,"+
      "Kdv double,"+
      "Tutar double,"+
      "KdvOran double,"+
      "SlsMan double,"+
      "Sign double,"+
      "SaticiRef double,"+
      "Maliyet double,"+
      "NetFiyat double,"+
      "siparisID double,"+
      "UrunName text,"+
      "ItemsRef double,"+
      "SIPARIS_DURUM_ID double"+
       ")");


    

      tx.executeSql(
        "CREATE TABLE IF NOT EXISTS M_SERVICE_INFO " +
        "(" +
        "ID INTEGER PRIMARY KEY ASC," +
        "ADRES text," +
        "SERVIS_TANIMI text," +
        "VARSAYILAN INTEGER" +
        ")");

        tx.executeSql(
          "CREATE TABLE IF NOT EXISTS RafEtiket " +
          "(" +
          "Id double,"+
          "StokKartiID double,"+
          "StokAdi string"+ 
          ")");
          tx.executeSql(
            "CREATE TABLE IF NOT EXISTS KullaniciType " +
            "(" +
            "ID INTEGER PRIMARY KEY ASC,"+
            "Type double"+
            ")");
            tx.executeSql(
              "CREATE TABLE IF NOT EXISTS M_REMEMBER_ACC" +
              "(" +
              "ID INTEGER PRIMARY KEY ASC," +
              "Sifre double," +
              "Name text," +
              "Type double," +
              "YetTip double" +
              ")");


  }


 

}



// WEBPACK FOOTER //
// ./src/providers/dal/dal.ts